import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Button from '../../../../../../../../components/Button'

import hocConnect from './hocConnect'

@hocConnect
export default class ConnectButton extends Component {
    static propTypes = {
        active: PropTypes.bool.isRequired,
        arrayName: PropTypes.string.isRequired,
        isNew: PropTypes.bool,
        moduleName: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        toggleButtonsArrayButton: PropTypes.func.isRequired,
    }

    static defaultProps = {
        onChange: () => {},
    }

    onClickHandler = () => {
        const { arrayName, moduleName, name, onChange, toggleButtonsArrayButton } = this.props

        toggleButtonsArrayButton(moduleName, arrayName, name)
        onChange(moduleName, arrayName, name)
    }

    render() {
        const { active, isNew } = this.props

        return <Button {...this.props} active={active} isNew={isNew} onClickHandler={this.onClickHandler} />
    }
}
